import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TslToastrService } from '@tesla/ng-tds';
import { TaxEditComponent } from 'app/common/tax/tax-edit.component';
import { GeneralSettings } from 'app/profile/models/generic.model';
import { OnboardingDocument } from 'app/profile/models/onboarding.model';
import { SupplierTax } from 'app/profile/models/supplier.model';
import { SupplierTaxInfo, TaxCountryConfig, TaxIDType } from 'app/profile/models/tax.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-tax-task-dialog',
  templateUrl: './tax-task-dialog.component.html',
  styleUrls: ['./tax-task-dialog.component.scss']
})
export class TaxTaskDialogComponent implements OnInit {

  @ViewChild('taxEditComponent', { static: false }) taxEditComponent: TaxEditComponent;
  supplierCode: string;
  requiredDocuments: OnboardingDocument[];
  supplierTax: SupplierTaxInfo;
  taxDocuments: any;
  settings$: Observable<GeneralSettings>;
  taxCountries$: Observable<TaxCountryConfig[]>;
  taxIdTypes$: Observable<TaxIDType[]>;
  readOnly: boolean = false;
  taskStatus:string;

  constructor(
    public dialogRef: MatDialogRef<TaxTaskDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private toaster: TslToastrService,
  ) { }

  ngOnInit(): void {
    if(this.data) {
      this.supplierCode = this.data?.supplierCode;
      this.requiredDocuments = this.data?.requiredDocuments;
      this.supplierTax = this.data?.supplierTax;
      this.taxDocuments = this.data?.taxDocuments;
      this.settings$ = this.data?.settings$;
      this.taxCountries$ = this.data?.taxCountries$;
      this.taxIdTypes$ = this.data?.taxIdTypes$;
      this.readOnly = this.data?.readOnly;
      this.taskStatus = this.data?.taskStatus
    }
  }

  taxFormSubmit(supplierTax: SupplierTax) {
    if (supplierTax) {
      this.dialogRef.close(supplierTax);
    } else this.toaster.error("Something went wrong, please check.");
  }

  setErrorMessage(message: string) {
    if (message) this.toaster.error((message && message.trim() != '') ? message : 'Something went wrong!')
  }

  onSubmit() {
    this.taxEditComponent.onSubmit();
  }

  onClose() {
    this.dialogRef.close();
  }

}
